import { Link } from "react-router-dom";
import styles from "../styles/ArtworkCard.module.css";
import { Artwork } from "../types";

export const ArtworkCard = ({ artwork }: { artwork: Artwork }) => (
  <Link to={`/artworks/${artwork.id}`} className={styles.cardLink}>
    <div className={styles.card}>
      <div className={styles.imageContainer}>
        <img
          src={artwork.imageUrl}
          alt={artwork.title}
          className={styles.image}
        />
      </div>
      <div className={styles.overlay}>
        <h3 className={styles.title}>{artwork.title}</h3>
        <p className={styles.meta}>
          {artwork.year} • {artwork.tags.join(" / ")}
        </p>
      </div>
    </div>
  </Link>
);
